import { render, staticRenderFns } from "./DeleteButton.vue?vue&type=template&id=45f32482&scoped=true&"
import script from "./DeleteButton.vue?vue&type=script&lang=js&"
export * from "./DeleteButton.vue?vue&type=script&lang=js&"
import style0 from "./DeleteButton.vue?vue&type=style&index=0&id=45f32482&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45f32482",
  null
  
)

export default component.exports